import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'enviroments/environment';
import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Injectable({providedIn: 'root'})

export class ApiService {
    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar,
        private fuseConfirm: FuseConfirmationService,
        private confirmDialog: FuseConfirmationService,
    ) { }

    get serverUrl() {
        return `${environment.API_SERVER_URL}/api`
    }

    GetMethod(_url: string, params?: any, errorMessage?:string){
        const url = `${this.serverUrl}${_url}`;
        return this.http.get(url, { params })
                        .pipe(
                            tap(() => {}),
                            catchError((error: HttpErrorResponse) => {
                                //
                                const _message = this.build_error_message(error,  errorMessage);
                                this.showErrorMessage(_message);
                                return throwError(() => error);
                            })
                        );
    }


    PostMethod(_url: string, body:any, params?: any, errorMessage?:string){
        const url = `${this.serverUrl}${_url}`;
        return this.http.post(url, body, { params })
                        .pipe(
                            tap(() => {}),
                            catchError((error: HttpErrorResponse) => {
                                const _message = this.build_error_message(error,  errorMessage);
                                this.showErrorMessage(_message);
                                return throwError(() => error);
                            })
                        );
    }

    PutMethod(_url: string, body:any, params?: any, errorMessage?:string) {
        const url = `${this.serverUrl}${_url}`;
        return this.http.put(url, body, { params })
                        .pipe(
                            tap(() => {}),
                            catchError((error: HttpErrorResponse) => {
                                const _message = this.build_error_message(error,  errorMessage);
                                this.showErrorMessage(_message);
                                return throwError(() => error);
                            })
                        );
    }

    DeleteMethod(_url: string,  params?: any, errorMessage?:string) {
        const url = `${this.serverUrl}${_url}`;
        return this.http.delete(url, { params })
                        .pipe(
                            tap(() => {}),
                            catchError((error: HttpErrorResponse) => {
                                const _message = this.build_error_message(error,  errorMessage);
                                this.showErrorMessage(_message);
                                return throwError(() => error);
                            })
                        );
    }


    build_error_message(error: HttpErrorResponse, message?:string){
        let server_error_response = error.error  ?? ''
        return `Error ${error.status} - ${message} - el servidor respondió ${JSON.stringify(server_error_response)}`;
    }

    showErrorMessage(message?:string){
        return  this.fuseConfirm.open( {
            title: 'Ups!',
            message: message,
            icon: {
                show: true,
                name: 'error',
                color:'warning'
            },
            actions: {
                confirm: { show: false},
                cancel: {show:  true}
            },
            dismissible:true

        })

    }

    showSuccessMessage(message?: string){
        return this.snackBar.open(
            message,
            '',
            {
                duration: 4000,
                verticalPosition: 'top',
                panelClass: ['bg-sky-400/70', 'text-white']
            },

        )

    }

    open_confirm_dialog(message: string, _title?: string): Observable<any> {
        let title  = (_title) ? _title : 'Confirmar Acción';

        const dialog =this.confirmDialog.open(
            {
                title,
                message,
                dismissible: true,
                actions: {
                    confirm: {
                        show: true,
                        label: "Continuar"
                    },
                    cancel: {
                        show:true,
                        label: 'Cancelar'
                    }
                }
            }
        )

        return dialog.afterClosed()
    }
}
